import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a phone number for display
 * Strips +1 prefix and formats as (XXX) XXX-XXXX
 */
export function formatPhoneDisplay(phone: string | null | undefined): string {
  if (!phone) return 'N/A';
  return phone.replace(/^\+1/, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}
